import { createFileRoute, redirect } from '@tanstack/react-router'
import dayjs from 'dayjs'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { parseDateRange } from '@/lib/date'
import { Permission } from '@/lib/permissions'

export const defaultDateRange = parseDateRange({
  startDate: dayjs().subtract(30, 'day').toDate(),
  endDate: dayjs().toDate(),
})

export const SearchSchema = z.object({
  tab: z.union([z.literal('my-alerts'), z.literal('alert-configuration'), z.literal('consumption')]).default('my-alerts'),
  startDate: z.string().default(defaultDateRange.startDate),
  endDate: z.string().default(defaultDateRange.endDate),
  deviceIds: z.array(z.string()).optional(),
})

export type Search = z.infer<typeof SearchSchema>

export function useSearch() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  const setSearch = (search: Search) => {
    void navigate({
      search,
      replace: true,
    })
  }

  return { search, setSearch }
}

export const Route = createFileRoute('/_dashboard/site/$id/alerts/')({
  validateSearch: SearchSchema,
  beforeLoad({ search, context }) {
    if ((search.tab === 'alert-configuration' || search.tab === 'consumption') && !context.user?.hasPermission(Permission.ALERT_CONFIGURATION)) {
      throw redirect({
        to: '/403',
      })
    }
  },
  pendingComponent: PendingComponent,
})
